<template>
  <v-card class="text-center full-width" color="#242424" dark width="909">
    <v-row align="center" justify="center">
      <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      <div>
        <div class="green--text d-flex flex-column">soll_daten</div>
        <v-card
          class="d-flex flex-row ml-7 mr-7 mt-2 justify-space-around"
          color="#242424"
          width="590"
        >
          <div
            v-for="(item, index) in data.item.soll_daten"
            class="green--text"
          >
            {{ item }}
          </div>
        </v-card>
      </div>
      <div>
        <div class="deep-orange--text">ist_daten</div>
        <v-card
          class="d-flex flex-row ml-7 mr-7 mt-2 justify-space-around"
          color="#242424"
          width="590"
        >
          <div
            v-for="(item, index) in data.item.forecast_daten"
            class="deep-orange--text"
          >
            {{ item }}
          </div>
        </v-card>
      </div>
      <v-card-text class="mt-6">
        <div class="font-weight-bold mt-2">
          {{ data.item.name }} arbeitet in {{ data.item.department }}
        </div>
      </v-card-text>
    </v-row>
  </v-card>
</template>
<script>
import { GChart } from "vue-google-charts";
export default {
  components: {
    GChart,
  },
  props: ["data"],
  data() {
    return {
      chartData: [],
      chartOptions: {
        width: 900,
        height: 300,
        chart: {
          title: "Company Performance",
          subtitle: "Sales, Expenses, and Profit: 2014-2017",
        },
        curveType: "function",
        legend: { position: "top" },
        animation: {
          duration: 1000,
          easing: "linear",
          startup: true,
        },
        hAxis: {
          baselineColor: "red",
          gridlines: { color: "#orange", minSpacing: 20 },
          textStyle: { color: "white" },
        },
        vAxis: {
          baselineColor: "red",
          gridlines: { color: "#orange", minSpacing: 30 },
          textStyle: { color: "white" },
        },
        legend: {
          position: "top",
          textStyle: { color: "white", fontSize: 12 },
        },
        backgroundColor: {
          fill: "#242424",
        },
        colors: ["green", "#ff4800"],
      },
    };
  },
  created() {
    this.fetch(this.data);
    EventBus.$on("diagrammUpdate", (data) => {
      this.fetch(data);
    });
  },
  methods: {
    fetch(data) {
      this.chartData = null;
      let array = [];
      array.push(["Monaten", "Soll-Daten", "ist-Data"]);
      for (let i = 1; i < data.headers.length - 4; i++) {
        let temp = [];
        temp.push(data.headers[i + 3].text);
        temp.push(data.item.soll_daten[i - 1]);
        temp.push(data.item.forecast_daten[i - 1]);
        array.push(temp);
      }
      this.chartData = array;
    },
  },
};
</script>